/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
		constructor() {
			super();
			this.pageHeight = window.innerHeight;
			this.isTargetPage = this.checkIfTargetPage();
		}

		connectedCallback() {
			if (!this.isTargetPage) return;

			this.addEventListener('click', this.onClick);
			window.addEventListener('scroll', this.checkVisible.bind(this));
		}

		checkIfTargetPage() {
			const url = window.location.pathname;
			if (url.includes('/collections')) {
				const chatButton = document.getElementById('easychat-floating-button');
				if (chatButton) chatButton.style.display = 'none';
				return true;
			}

			return false;
		}

		checkVisible(event) {
			window.requestAnimationFrame(() => {
				let y = window.scrollY;
				if (y > this.pageHeight) {
					this.classList.add('back-to-top--active');
				} else {
					this.classList.remove('back-to-top--active');
				}
			});
		}

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		}
	}
	customElements.define('back-to-top', BackToTop);
}
